import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import styles from './MeetBellona.module.scss'
import TitleFlex from 'components/services/commons/TitleFlex'

gsap.registerPlugin(ScrollTrigger)

const tweenVars: gsap.TimelineVars = [
  {
    y: '50',
    duration: 1,
    opacity: 0,
    ease: Power4.easeOut,
  },
  {
    x: '-50',
    duration: 0.5,
    opacity: 0,
    ease: Power4.easeOut,
  },
  {
    duration: 1,
    width: '40px',
    border: '1px solid #3C3C3C',
    ease: Power4.easeOut,
  },
]

export interface TextList {
  text: string[]
}
export interface ImageList {
  src: string
  youtube?: boolean
}

interface Props {
  list: {
    content: TextList[]
    img: ImageList[]
  }
}

const MeetBellona: React.FC<Props> = ({ list }) => {
  const timeline = gsap.timeline()

  const trigger = useRef<HTMLDivElement>()
  const group = useRef<HTMLDivElement>()
  const imgGroup = useRef<HTMLDivElement>()

  useEffect(() => {
    Array.prototype.forEach.call(group.current.children, (element: HTMLElement, index: number) => {
      timeline
        .from(element.children[0], tweenVars[0], 0.5 + index * 0.3)
        .from(element.children[1], tweenVars[0], 0.6 + index * 0.3)
        .from(element.children[2], tweenVars[0], 0.7 + index * 0.3)
        .from(element.children[3], tweenVars[0], 0.7 + index * 0.3)
        .from(element.children[4], tweenVars[0], 0.8 + index * 0.3)
        .from(element.children[5], tweenVars[0], 0.9 + index * 0.3)
        .from(element.children[6], tweenVars[0], 0.9 + index * 0.3)
        .from(element.children[7], tweenVars[0], 1.0 + index * 0.3)
        .from(element.children[8], tweenVars[0], 1.1 + index * 0.3)
    })
    Array.prototype.forEach.call(imgGroup.current.children, (element: HTMLElement, index: number) => {
      timeline
        .from(element.children[0], tweenVars[0], 1.3 + (index + 7) * 0.3)
        .from(element.children[1], tweenVars[0], 1.5 + (index + 8) * 0.3)
    })

    ScrollTrigger.create({
      animation: timeline,
      trigger: trigger.current,
      start: 'top-=250 70%',
      toggleActions: 'play none none reverse',
    })
  }, [])

  const CheckTextList = list.content.map((item, index) => (
    <div key={index} className={styles.check_list_item}>
      <img src="/images/icons/meet_bellona_check.svg" alt="check" />
      <p className={styles.check_list_item_text}>{item.text}</p>
    </div>
  ))

  return (
    <section className={styles.wrapper} ref={trigger}>
      <div className={styles.inner}>
        <TitleFlex
          sectionTitle={{ title: 'Bellona project', sub_title: '生成AIに特徴量エンジアリングを使ったUI生成のR&D事例' }}
          adjustWide
        />
        <div className={styles.contentsWrapper}>
          <div ref={group} className={styles.check_list}>
            {CheckTextList}
          </div>
          <div ref={imgGroup}>
            <div className={styles.inner_image}>
              <img src={`${list.img[0].src}`} alt="" className={styles.inner_image_thumbnail} />
              <div className={styles.inner_image_thumbnail}>
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/6RwKQYPSwNs"
                  title="Bellona AI generating e-commerce pages"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default MeetBellona
